import { useRouter } from "@tanstack/react-router";
import { Copy as CopyIcon } from "lucide-react";
import { useState } from "react";
import QRCode from "react-qr-code";
import { toast } from "sonner";
import type { ToT } from "../../../route-types";

function QRCodeRoute(
    { route, title }: {
        route: ToT;
        title: string;
    },
) {
    const router = useRouter();

    const destinationUrl = window.location.origin +
        router.buildLocation(route).href;

    return (
        <div className="flex flex-col items-center gap-4 mx-auto w-full max-w-md">
            <div className="flex justify-center items-center bg-white shadow-lg p-4 rounded-2xl rounded-md w-[70vw] md:w-[300px] lg:w-[400px] h-[70vw] md:h-[300px] lg:h-[400px]">
                <QRCode
                    value={destinationUrl}
                    size={220}
                    className="rounded-2xl"
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    viewBox="0 0 256 256"
                    title={title}
                />
            </div>
            <CopyMonoLink destinationUrl={destinationUrl} />
        </div>
    );
}

function CopyMonoLink({ destinationUrl }: { destinationUrl: string }) {
    const [copied, setCopied] = useState(false);

    function handleCopy() {
        navigator.clipboard.writeText(destinationUrl);
        setCopied(true);
        toast.success("Copied to clipboard");
        setTimeout(() => setCopied(false), 1000);
    }

    return (
        <div
            className={`flex items-center gap-2 w-[70vw] md:w-[300px] lg:w-[400px] border border-slate-200 bg-slate-50 rounded-sm px-2 py-1 cursor-pointer select-all transition-all${
                copied
                    ? "bg-green-50 border-indigo-400 animate-wiggle"
                    : "hover:border-slate-400 hover:bg-slate-100"
            }`}
            onClick={handleCopy}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") handleCopy();
            }}
            tabIndex={0}
            role="button"
            aria-label="Copy invite link"
        >
            <span className="flex-1 font-mono text-xs truncate select-all">
                {destinationUrl}
            </span>
            <CopyIcon
                size={18}
                className={copied
                    ? "text-indigo-500 scale-105"
                    : "text-slate-500"}
            />
        </div>
    );
}

export default QRCodeRoute;
